import { GameConstants } from './../../../../GameConstants';
import { GameVars } from "./../../../../GameVars";
import { SelectTurretButton } from "./SelectTurretButton";

export class SelectTurretMenu extends Phaser.GameObjects.Container {

    public flagPosition: {c: number, r: number};
    public buttons: SelectTurretButton[];

    private f: number;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.buttons = [];

        this.visible = false;

        this.f = -1;

        if (!this.scene.sys.game.device.os.desktop) {
            this.setScale(1 + (GameVars.aspectRatio - (4 / 3)) * .5);
            this.scaleX *= (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
        }

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(time: number, delta: number): void {

        if (this.f !== -1) {
            this.f++;
            if (this.f >= 120) {
                this.hide(true);
            }
        }
    }

    public show(c: number, r: number): void {
        
        this.f = 0;

        this.visible = true;
        this.flagPosition = {c: c, r: r};

        for (let i = 0; i < this.buttons.length; i++) {

            this.buttons[i].destroy();
        }

        let numTurrets = 8;
        let radius = 60;

        this.buttons = [];

        let pos = [{x: 0, y: -radius}, {x: radius, y: -radius}, {x: radius, y: 0}, {x: radius, y: radius}, {x: 0, y: radius}, {x: -radius, y: radius}, {x: -radius, y: 0}, {x: -radius, y: -radius}];

        for (let i = 0; i < numTurrets; i++) {

            let selectTurretButton = new SelectTurretButton(this.scene, pos[i].x, pos[i].y, i, this);
            this.add(selectTurretButton);
            this.buttons.push(selectTurretButton);
        }
    }

    public hide(checkPosition?: boolean): void {

        if (checkPosition && this.scene.sys.game.device.os.desktop) {

            let x = this.x + GameConstants.GAME_WIDTH / 2;
            if (x - 100 < this.scene.input.activePointer.x && x + 100 > this.scene.input.activePointer.x) {
                if (this.y - 100 < this.scene.input.activePointer.y && this.y + 100 > this.scene.input.activePointer.y) {
                    this.f = 0;
                    return;
                }
            }
        }

        this.f = -1;

        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 100,
            onComplete: () => {
                this.visible = false;
                this.alpha = 1;
            },
            onCompleteScope: this
        });
    }
}
